import type { AppContext } from "@/models";

// Map settings for different cities
const cityMapSettings: Record<
  AppContext,
  {
    center: { lon: number; lat: number };
    zoom: number;
    pitch: number;
    bearing: number;
  }
> = {
  grasbrook: {
    center: { lon: 10.016559479451644, lat: 53.53128655676443 },
    zoom: 14.65,
    pitch: 48,
    bearing: -14.2,
  },
  schb: {
    center: { lon: 10.016559479451644, lat: 53.53128655676443 }, // TODO: Update with Science City coordinates
    zoom: 14.65,
    pitch: 48,
    bearing: -14.2,
  },
  dresden: {
    center: { lon: 13.7373, lat: 51.0504 }, // Dresden city center
    zoom: 14.65,
    pitch: 48,
    bearing: -14.2,
  },
  phnompenh: {
    center: { lon: 104.94555985, lat: 11.54717985 }, // Center of bounds: [104.928728, 11.5307325, 104.9623917, 11.5636272]
    zoom: 14.65,
    pitch: 48,
    bearing: -14.2,
  },
  mekong01: {
    center: { lon: 104.94555985, lat: 11.54717985 }, // TODO: Update with Mekong01 coordinates
    zoom: 14.65,
    pitch: 48,
    bearing: -14.2,
  },
};

// Default settings (used as fallback)
const defaultSettings = {
  view: {
    center: { lon: 10.016559479451644, lat: 53.53128655676443 },
    zoom: 14.65,
    pitch: 48,
    bearing: -14.2,
  },
  geoJsonOptions: {},
  minZoom: 0,
  maxZoom: 22,
  styleUrl:
    "https://api.maptiler.com/maps/c4b89bbb-8c0f-4230-aaed-62bc8cd1abc4/style.json?key=P9weUvTI84TqkNu8Us6m",
};

// Function to get map settings based on context
export function getMapSettingsForContext(context: AppContext | null) {
  if (context && cityMapSettings[context]) {
    return {
      ...defaultSettings,
      view: cityMapSettings[context],
    };
  }
  return defaultSettings;
}

export default defaultSettings;
